/**
 * The editable fields of the Edit User form (PD-4068), in one place.
 *
 * Keys are the camelCase names Management::UserDetail sends and the form holds;
 * values are the snake_case parameters Management::UsersController permits. Keeping
 * the pairing here means adding a field is one line rather than three scattered
 * ones, and the form cannot send something the controller will silently drop.
 *
 * `username` is absent on purpose: it renders disabled, and the controller does not
 * permit it.
 */
export const EDITABLE_FIELDS = {
  firstName: 'first_name',
  lastName: 'last_name',
  email: 'email',
  jobRole: 'job_role',
  dmsId: 'dms_id',
  mobileCountryCode: 'mobile_country_code',
  mobile: 'mobile',
  phoneCountryCode: 'phone_country_code',
  phone: 'phone',
  faxCountryCode: 'fax_country_code',
  fax: 'fax',
  address1: 'address1',
  address2: 'address2',
  countryCode: 'country_code',
  state: 'state',
  city: 'city',
  postalCode: 'postal_code',
};

/**
 * The fields the design marks with an asterisk, which are also the three the model
 * actually enforces for a non-external user (see User's validates_presence_of and
 * its email presence validation). Username is required too but is not editable.
 */
export const REQUIRED_FIELDS = ['firstName', 'lastName', 'email'];

/**
 * Every value as a string, so an input is never handed null and React never warns
 * about switching between controlled and uncontrolled.
 */
export const toFormValues = (user) =>
  Object.keys(EDITABLE_FIELDS).reduce((values, name) => {
    const value = user[name];

    return {
      ...values,
      [name]: value === null || value === undefined ? '' : String(value),
    };
  }, {});

/** The form's values as the parameters the controller permits. */
export const toParams = (values) =>
  Object.entries(EDITABLE_FIELDS).reduce(
    (params, [name, param]) => ({ ...params, [param]: values[name] }),
    {},
  );
